import { DeviceIcon } from '@2n/design-system';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { FormattedMessage } from 'react-intl';
import messages from './messages';

const styles = {
  description: {
    p: 2,
    typography: 'caption',
  },
  icon: {
    '& img': {
      height: 'inherit',
    },
    height: 'inherit',
    paddingTop: '5px',
    width: 'inherit',
  },
  root: {
    alignItems: 'center',
    background: 'secondary.light',
    borderRadius: '168px',
    boxShadow: 3,
    display: 'flex',
    height: '168px',
    justifyContent: 'center',
    position: 'relative',
    textAlign: 'center',
    width: '168px',
  },
};

function transformDeviceType(deviceType?: string) {
  if (!deviceType) {
    return '0-0-0-0';
  }
  const parts = deviceType.split('.');

  if (parts.length >= 2) {
    parts[parts.length - 1] = '0';
    parts[parts.length - 2] = '0';
  } else if (parts.length === 1) {
    parts[0] = '0';
  }
  return parts.join('-');
}

export interface IDevice2NIconProps {
  deviceType?: string;
  noFound?: boolean;
}

export function Device2NIcon({ deviceType, noFound = false }: IDevice2NIconProps) {
  const transformedDeviceType = transformDeviceType(deviceType);
  return (
    <Box sx={styles.root}>
      {!noFound && deviceType && (
        <Box sx={styles.icon}>
          <DeviceIcon id={transformedDeviceType} size={144} />
        </Box>
      )}
      {noFound && !deviceType && (
        <Typography color="error.main" component="span" sx={styles.description}>
          <FormattedMessage {...messages.device2NIconNotBeAdded} />
        </Typography>
      )}
      {!noFound && !deviceType && (
        <Typography color="secondary.main" component="span" sx={styles.description}>
          <FormattedMessage {...messages.device2NIconNoTypeMessage} />
        </Typography>
      )}
    </Box>
  );
}
